import { useEffect, useState } from 'react';
import { usePoint } from '../context/PointContext';
import { Link } from 'react-router-dom';

function PointBox() {
    const memberId = localStorage.getItem("lighthouse_memberId");
    const isLoggedIn = memberId && memberId !== 'null' && memberId !== 'undefined';

    const {
        point,
        todayAttendance,
        loading,
        fetchPoint,
        checkAttendance
    } = usePoint();

    const [showReward, setShowReward] = useState(false);
    const [earnedPoint, setEarnedPoint] = useState(0);

    useEffect(() => {
        if (isLoggedIn) {
            fetchPoint(memberId);
        }
    }, [isLoggedIn, memberId, fetchPoint]);

    const handleAttendance = () => {
        checkAttendance(memberId, (earned) => {
            setEarnedPoint(earned);
            setShowReward(true);
            setTimeout(() => setShowReward(false), 2000);
        });
    };

    if (!isLoggedIn) {
        return null;
    }

    return (
        <div className="pointBoxWrapper">
            <div className='myPointBox_inner'>
                <Link to="/lighthouse/point-history" style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    textDecoration: 'none'
                }}>
                    <span style={{ fontSize: '20px' }}>&#11088;</span>
                    <div>
                        <div style={{ fontSize: '11px', color: '#aaa' }}>내 포인트</div>
                        <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#FFD700' }}>
                            {point.toLocaleString()}P
                        </div>
                    </div>
                </Link>

                <button
                    className='myPointBtn'
                    onClick={handleAttendance}
                    disabled={loading || todayAttendance}
                    style={{
                        fontWeight: 'bold',
                        color: todayAttendance ? '#fff' : '#fff',
                        background: todayAttendance
                            ? 'rgba(255,255,255,0.25)'
                            : 'linear-gradient(135deg, #FFD700 0%, #FFA500 100%)',
                        border: todayAttendance ? '1px solid rgba(255,255,255,0.3)' : 'none',
                        cursor: todayAttendance ? 'default' : 'pointer',
                        transition: 'all 0.2s ease',
                        whiteSpace: 'nowrap',
                        flexShrink: 0
                    }}
                >
                    {loading ? '...' : todayAttendance ? '출석완료 ✓' : '출석체크'}
                </button>
            </div>

            {showReward && (
                <div style={{
                    position: 'fixed',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    background: 'rgba(0,0,0,0.9)',
                    padding: '30px 50px',
                    borderRadius: '16px',
                    textAlign: 'center',
                    zIndex: 9999,
                    animation: 'fadeIn 0.3s ease'
                }}>
                    <div style={{ fontSize: '48px', marginBottom: '10px' }}>&#127881;</div>
                    <div style={{ fontSize: '14px', color: '#aaa', marginBottom: '5px' }}>
                        출석체크 완료!
                    </div>
                    <div style={{ fontSize: '24px', fontWeight: 'bold', color: '#FFD700' }}>
                        +{earnedPoint}P
                    </div>
                </div>
            )}
        </div>
    );
}

export default PointBox;
